import { Card, Flex, Typography } from 'antd';
import type { ReactNode } from 'react';

const { Text, Title } = Typography;

/** One headline figure with its label and a line or two beneath. */
export function Tile({
  id,
  label,
  value,
  children,
}: {
  id: string;
  label: ReactNode;
  value: string;
  children?: ReactNode;
}): ReactNode {
  return (
    <Card size="small" style={{ height: '100%' }} data-testid={`tile-${id}`}>
      <Flex vertical gap={4}>
        <Text type="secondary">{label}</Text>
        <Title level={3} className="tabular" style={{ margin: 0, overflowWrap: 'anywhere' }}>
          {value}
        </Title>
        {children}
      </Flex>
    </Card>
  );
}
